import axios from 'axios'

export default {
    getService(){
        return axios.get('/servicetype')
            .then(response => {
                return response.data
            })
    },
    getServiceDataSource(params){
        return axios.get('/servicetype/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getServicebyID(id){
        return axios.get('/servicetype/' + id)
            .then(response => {
                return response.data
            })
    },    
    createService(formdata){
        return axios.post('/servicetype', formdata)
            .then(response => {
                return response.data
            })
    },
    updateService(id,formdata){
        return axios.put('/servicetype/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateService(id){
        return axios.put('/servicetype/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateService(id){
        return axios.put('/servicetype/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    getCovenant(id){
        return axios.get('/member/covenant/' + id )
            .then(response => {
                return response.data
            })
    },
    getBaptism(id){
        return axios.get('/member/baptism/' + id )
            .then(response => {
                return response.data
            })
    },
    getMarriage(id){
        return axios.get('/member/marriage/' + id )
            .then(response => {
                return response.data
            })
    },

    //SERVICE TYPE FOR SERVICE ATTENDANCE
    getServiceType(){
        return axios.get('/servicetype/')
            .then(response => {
                return response.data
            })
    }, 
    getServiceTypeOnlyActive(){
        return axios.get('/servicetype/?is_active=1')
            .then(response => {
                return response.data
            })
    },
        //SERVICE ATTENDANCE
    getServiceAttendance(){
        return axios.get('/service/attendance')
            .then(response => {
                return response.data
            })
    },
    getServiceAttendanceDataSource(params){
        return axios.get('/service/attendance/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getServiceAttendancebyID(id){
        return axios.get('/service/attendance/' + id)
            .then(response => {
                return response.data
            })
    },    
    createServiceAttendance(formdata){
        return axios.post('/service/attendance', formdata)
            .then(response => {
                return response.data
            })
    },
    updateServiceAttendance(id,formdata){
        return axios.put('/service/attendance/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateServiceAttendance(id){
        return axios.put('/service/attendance/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateServiceAttendance(id){
        return axios.put('/service/attendance/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },

    //SERVICE ATTENDANCE
    getServiceAttendance(){
        return axios.get('/service/attendance')
            .then(response => {
                return response.data
            })
    },
    getServiceAttendanceDataSource(params){
        return axios.get('/service/attendance/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getServiceAttendancebyID(id){
        return axios.get('/service/attendance/' + id)
            .then(response => {
                return response.data
            })
    },    
    createServiceAttendance(formdata){
        return axios.post('/service/attendance', formdata)
            .then(response => {
                return response.data
            })
    },
    updateServiceAttendance(id,formdata){
        return axios.put('/service/attendance/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateServiceAttendance(id){
        return axios.put('/service/attendance/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateServiceAttendance(id){
        return axios.put('/service/attendance/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },    
   
}